module.exports = __webpack_public_path__ + "static/media/fondo_vertical.61306968.bin";